import { cva } from 'class-variance-authority';

/**
 * 层级列表「行」的共享样式，供 `tree.tsx`（文件树皮肤）与 `sidebar-menu.tsx`
 * （导航菜单皮肤）复用，使两者的行高/hover/选中/落点观感一致。
 *
 * 放在 `components/` 内而非 `lib/` 是硬约束：`src/styles.css` 只
 * `@source './components'`，`lib/` 下的类名不会被 Tailwind 扫描（构建全绿但样式为空）。
 *
 * 状态用 data 属性驱动而非条件类名，便于消费方用 `[data-*]` 选择器再覆盖。
 * 基础串与尺寸表单独导出，供菜单皮肤在其上叠加自己的变体而不复制样式。
 */
const navRowBase =
  "group/nav-row relative flex w-full cursor-pointer items-center gap-1.5 rounded-md text-left whitespace-nowrap  outline-none select-none hover:bg-muted data-[active=true]:bg-accent data-[active=true]:text-accent-foreground data-[active=true]:font-medium data-[drop=true]:bg-primary/10 data-[drop=true]:ring-1 data-[drop=true]:ring-primary/40 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4";

const navRowSizes = {
  sm: 'h-6 px-1.5 text-xs',
  md: 'h-7 px-2 text-sm',
} as const;

const navRowVariants = cva(
  [navRowBase, 'focus-visible:ring-2 focus-visible:ring-ring/50'],
  {
    variants: {
      size: navRowSizes,
    },
    defaultVariants: {
      size: 'md',
    },
  },
);

export { navRowBase, navRowSizes, navRowVariants };
